import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import './index.css'

const useIsDesktop = () => {
    const [isDesktop, setIsDesktop] = useState(
        typeof window !== "undefined" ? window.innerWidth >= 1024 : false
    );

    useEffect(() => {
        const handleResize = () => {
            setIsDesktop(window.innerWidth >= 1024);
        };

        window.addEventListener("resize", handleResize);
        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);

    return isDesktop;
};

const RightAbout = () => {
    const isDesktop = useIsDesktop();

    const animationProps = isDesktop
        ? { initial: { opacity: 0, x: -40 }, whileInView: { opacity: 1, x: 0 } }
        : { initial: { opacity: 0, y: 20 }, whileInView: { opacity: 1, y: 0 } };

    return (
        <motion.div
            className="text-container"
            {...animationProps}
            viewport={{ once: true, amount: 0.3 }}
            transition={{ duration: 0.5, ease: "easeOut" }}
        >
            <p className="about-me-text">
                Hello! I'm <span className="highlight-text">Aguru Sireesha</span>, 
                a final-year BTech student at Centurion University of Technology and Management, 
                set to graduate by the end of this year. With a solid foundation in 
                <span className="highlight-text"> Computer Science and Engineering</span>,
                I am actively seeking a position in <span className="highlight-text">Full Stack Web Development</span>.
                <br/>
                <br/>
                I have completed extensive training in the <span className="highlight-text">MERN stack</span> 
                through <span className="highlight-text">Nxtwave</span>, where I honed my skills in building 
                dynamic and responsive web applications. I am proficient in <span className="highlight-text">Python</span> 
                and am currently learning <span className="highlight-text">Data Structures and Algorithms</span>. 
                My long-term goal is to pursue a career in <span className="highlight-text">AI/ML</span>.
                <br/>
                <br/>
                I am a disciplined, confident, and self-motivated team player with excellent communication skills. 
                Alongside my technical skills, I am also improving my <span className="highlight-text"> Soft skills </span> 
                and <span className="highlight-text">Presentation abilities</span> to become a well-rounded professional.
            </p>
        </motion.div>
    );
};

export default RightAbout;
